import React from 'react';
import { connect } from 'react-redux';


class SmallProgressBar extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'SmallProgressBar';
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const state = this.props.smallCardFrameworkState;
    const globalState = this.props.mediaLabCardFrameworkState;
    const progress = state.progress;
    const className = 'component-small-progress-bar';
    const style = {
      height: globalState.windowSize.height,
    };
    const progressStyle = {
      transform: 'scale3d(1, ' + progress + ', 1)',
    };

    return (
      <div
        style={style}
        className={className}
      >
        <div
          className='progress'
          style={progressStyle}
        />
      </div>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} cardAmount - The number of cards in the story
 * @prop {Object} mediaLabCardFrameworkState - The state of the
 * container component
 * @prop {Object} smallCardFrameworkState - The state of the
 * SmallCardFramework component
 */
SmallProgressBar.propTypes = {
  cardAmount: React.PropTypes.number.isRequired,
  mediaLabCardFrameworkState: React.PropTypes.object.isRequired,
  smallCardFrameworkState: React.PropTypes.object.isRequired,
};


export default connect(({ mediaLabCardFrameworkState, smallCardFrameworkState }) =>
  ({ mediaLabCardFrameworkState, smallCardFrameworkState }))(SmallProgressBar);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/cards/small/SmallProgressBar.jsx
 **/